// ─────────────────────────────────────────────
// PORTFOLIO DATA — Edit this file to update your portfolio
// Replace YouTube video IDs, titles, and descriptions
// ─────────────────────────────────────────────

export const siteConfig = {
  name: "HK Studios",
  tagline: "Video Editor",
  phone: "+91 9482006086",
  subTagline: "Crafting stories through motion & light",
  email: "hruthikkrishnat@gmail.com",
  location: "Bengaluru, India",
  availableForWork: true,
  socialLinks: {
    youtube: "https://youtube.com/@hkstudios-co",
    instagram: "https://www.instagram.com/hkstudios.co",
    linkedin: "https://www.linkedin.com/in/hruthikshetty/",
  },
};

// ─────────────────────────────────────────────
// FEATURED REEL — Main hero showreel
// Replace with your YouTube video ID
// ─────────────────────────────────────────────
export const showreel = {
  youtubeId: "MPz6S45CK0w", // Replace with your showreel YouTube video ID
  title: "Spec ad for Gemini⭐",
  description: "A collection of my finest work across brands, campaigns, and stories.",
};

// ─────────────────────────────────────────────
// PORTFOLIO WORKS
// Replace youtubeId with actual YouTube video IDs
// category: "commercial" | "social" | "brand" | "motion"
// ─────────────────────────────────────────────
export const works = [
  {
    id: 1,
    title: "Spec ad for Gemini⭐",
    client: "Showreel Project",
    category: "motion",
    year: "2025",
    youtubeId: "MPz6S45CK0w",
    thumbnail: null, // leave null to use YouTube's auto thumbnail
    tags: ["Motion Graphics", "sound design"],
    description: "A high-energy product launch campaign targeting Gen Z athletes. Fast cuts, kinetic typography.",
    featured: true,
  },
  {
    id: 2,
    title: "Ad for Clickup",
    client: "Showreel Project",
    category: "motion",
    year: "2025",
    youtubeId: "-TU3iqatmdc",
    thumbnail: null,
    tags: ["Motion Graphics"],
    description: "A 60-second emotional brand film that tells the story of natural beauty rituals.",
    featured: true,
  },
  {
    id: 3,
    title: "He spech ad",
    client: "He",
    category: "commercial",
    year: "2025",
    youtubeId: "41iW97P61Ig",
    thumbnail: null,
    tags: ["commercial", "brand", "product shoot"],
    description: "A series of 15-second product highlight reels optimized for Instagram and TikTok.",
    featured: false,
  },
  {
    id: 4,
    title: "Rugged soul Produuct Ad",
    client: "Rugged Soul",
    category: "brand",
    year: "2025",
    youtubeId: "Lp_penaQFmk",
    thumbnail: null,
    tags: ["Motion Graphics", "Kinetic Type"],
    description: "A motion-graphics driven manifesto film showcasing the brand identity.",
    featured: true,
  },
  {
    id: 5,
    title: "Durofelx Product Walkthrough",
    client: "Duroflex",
    category: "brand",
    year: "2025",
    youtubeId: "9Og1LrUMdxM",
    thumbnail: null,
    tags: ["Cinematic", "furniture", "Grade"],
    description: "Luxury sofa walkthrough with cinematic color treatment and ambient sound.",
    featured: false,
  },
  {
    id: 6,
    title: "Podar Internaltional School — Ad",
    client: "Podar",
    category: "commercial",
    year: "2025",
    youtubeId: "Xks6_OkjDSo",
    thumbnail: null,
    tags: ["Social Media", "Product", "Reels"],
    description: "Multi-format social campaign including Reels, Stories, and YouTube Shorts.",
    featured: false,
  },
  {
  id: 7,
  title: "Cometrank Explainer video",
  client: "Brandshark",
  category: "motion",
  year: "2025",
  youtubeId: "g9ZcnI_oJ58",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
  {
  id: 8,
  title: "Smylo Shark Tank Episode",
  client: "Smylo",
  category: "short form",
  year: "2025",
  youtubeId: "oJ_NA0Vbp8w",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: true,
  sharkTank: true,
},
{
  id: 9,
  title: "Brandshark Ad",
  client: "Brandshark",
  category: ["short form", "social"],
  year: "2025",
  youtubeId: "cZSiWLzZTMQ",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 10,
  title: "Shadow Light Studios Ad",
  client: "Shadow Light Studios",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "MKk3SnbiAyM",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 11,
  title: "Not every brand needs SEO",
  client: "Brandshark",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "-EADjMG4V1A",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 12,
  title: "Brandshark April 10 videos 120k",
  client: "Brandshark",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "SdeNScnkSt4",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 13,
  title: "Brandshark UGC Content",
  client: "Brandshark",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "Tt_S5iZCO8Q",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 14,
  title: "Brandshark quick commerce",
  client: "Brandshark",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "J33cHt647rc",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
{
  id: 15,
  title: "Brandshark production concept",
  client: "Brandshark",
  category: ["short form", "social", "brand"],
  year: "2025",
  youtubeId: "ruMxaKz1Qeo",
  thumbnail: null,
  tags: ["Reels", "Vertical", "TikTok"],
  description: "Vertical short form content optimized for Instagram Reels and TikTok.",
  featured: false,
},
];

// ─────────────────────────────────────────────
// SKILLS
// ─────────────────────────────────────────────DaVinci Resolve Adobe Premiere Pro After Effects
export const skills = [
  { name: "DaVinci Resolve", level: 95, category: "editing, color" },
  { name: "Adobe Premiere Pro", level: 85, category: "editing" },
  { name: "After Effects", level: 80, category: "motion" },
];

export const softSkills = [
  "Narrative Storytelling",
  "Color Psychology",
  "Pacing & Rhythm",
  "Client Communication",
  "Deadline-driven",
  "Detail-Obsessed",
];

// ─────────────────────────────────────────────
// SERVICES
// ─────────────────────────────────────────────
export const services = [
  {
    icon: "✂️",
    title: "Video Editing",
    description: "Full editing workflow from rough cut to final delivery. Premiere Pro & Final Cut.",
  },
  {
    icon: "🎨",
    title: "Color Grading",
    description: "Cinematic color treatment using DaVinci Resolve. From LOG to finished look.",
  },
  {
    icon: "⚡",
    title: "Motion Graphics",
    description: "Kinetic typography, animated lower thirds, and motion-driven brand films.",
  },
  {
    icon: "📱",
    title: "Social Media Edits",
    description: "Format-optimized edits for Instagram Reels, TikTok, and YouTube Shorts.",
  },
];

// ─────────────────────────────────────────────
// ABOUT
// ─────────────────────────────────────────────
export const about = {
  bio: `I'm a video editor based in Bengaluru with one year of professional experience at a leading ad agency. I believe every frame is a decision and every cut either serves the story or doesn't.

I specialize in commercial and brand content, helping companies tell their stories with clarity, rhythm, and impact. My work sits at the intersection of technical craft and creative instinct.`,
  stats: [
    { value: "1+", label: "Year at Agency" },
    { value: "30+", label: "Projects Delivered" },
    { value: "15+", label: "Brand Clients" },
    { value: "🦈", label: "Shark Tank India Client" },
  ],
};
